import { useAppSelector } from 'hooks/reduxHooks'
import { FLIGHTS_DISABLED_GEO_STATES } from 'constants/config/region'

function useIsFlightsDisabledForGeoState(): boolean {
  const geoStateName = useAppSelector((state) => state.geo.geoStateName)
  return !!geoStateName && FLIGHTS_DISABLED_GEO_STATES.includes(geoStateName)
}

export default useIsFlightsDisabledForGeoState
